import React, { createContext, useContext, useEffect, useState } from "react";

const DisplaysContext = createContext(null);

export const DisplaysProvider = ({ defaultNav, defaultLocation, children }) => {
  const [nav, setNav] = useState(defaultNav);
  const [openEdit, setOpenEdit] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [locationId, setLocationId] = useState(defaultLocation);
  const [layout, setLayout] = useState([]);

  useEffect(() => {
    setLocationId(defaultLocation);
  }, [defaultLocation]);

  return (
    <DisplaysContext.Provider
      value={{
        defaultNav,
        nav,
        setNav,
        locationId,
        setLocationId,
        openEdit,
        setOpenEdit,
        deletingId,
        setDeletingId,
        layout,
        setLayout,
      }}
    >
      {children}
    </DisplaysContext.Provider>
  );
};

export const useDisplaysContext = () => {
  const context = useContext(DisplaysContext);
  if (!context) {
    throw new Error("useDisplays must be used within a DisplaysProvider");
  }
  const {
    defaultNav,
    nav,
    setNav,
    locationId,
    setLocationId,
    openEdit,
    setOpenEdit,
    deletingId,
    setDeletingId,
    layout,
    setLayout,
  } = context;

  return {
    defaultNav,
    nav,
    setNav,
    locationId,
    setLocationId,
    openEdit,
    setOpenEdit,
    deletingId,
    setDeletingId,
    layout,
    setLayout,
  };
};
